import React from 'react';
export interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
}
export function Card({
  children,
  className = '',
  title,
  description,
  action
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-slate-200 shadow-sm ${className}`} data-id="element-55">
      {(title || action) && <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center" data-id="element-56">
          <div data-id="element-57">
            {title && <h3 className="text-lg font-serif font-semibold text-bank-navy" data-id="element-58">
                {title}
              </h3>}
            {description && <p className="text-sm text-slate-500 mt-1" data-id="element-59">{description}</p>}
          </div>
          {action && <div data-id="element-60">{action}</div>}
        </div>}
      <div className="p-6" data-id="element-61">{children}</div>
    </div>;
}